// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"82":"5a94b603","184":"c185e346","279":"5a94b603","285":"5a94b603"}[chunkId] + ".chunk.css";
};